// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"321":"0f8b9ce2","330":"4a136ee4","388":"639b3aed","396":"2baa1643","421":"0b95a458","655":"d3e4275c"}[chunkId] + ".chunk.css";
};